import React from 'react';
import { useParams } from 'react-router-dom';
import { PAGE_COMMON_TEXT } from '../lang';
import { waitingForProcessing } from '../WaitProcess';
import { Loading, Alert } from '../../../../components';
import { HoDDoSAssessmentContent } from '../../../Assessment';
import { useGetHoDDoSAssessment } from '../../../Assessment/graphql';

export const HoDDoSAssessmentForm: React.FunctionComponent = () => {
  const { applicationId = '' } = useParams();

  const { hodDosAssessment, loading, error } =
    useGetHoDDoSAssessment(applicationId);

  if (error) {
    return (
      <Alert
        openAlert
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  const hashodDosAssessed = hodDosAssessment?.submitted;

  return (
    <>
      {loading ? (
        <Loading />
      ) : hashodDosAssessed ? (
        <HoDDoSAssessmentContent isViewMode />
      ) : (
        waitingForProcessing(PAGE_COMMON_TEXT.SIDEBAR_TEXT.HOD_DOS_ASSESSMENT)
      )}
    </>
  );
};
